/* eslint-disable max-len */

import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import LetterCell from './components';
import getCurrentTime from '../../../utils';

function OSpanLetterMemory({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resultsCallback = () => {},
  grid,
  answers,
  trial,
  submitResults = false,
  displayResult = false,
  complete = false,
}) {
  const [startTime, setStartTime] = useState(0);
  const [clickTracker, setClickTracker] = useState([]);
  const [selections, setSelections] = useState([]); // eslint-disable-line
  const [content, setContent] = useState({});
  const [answered, setAnswered] = useState(false);
  const [correctAnswers, setCorrectAnswers] = useState(0);

  const recordClickEvent = (event) => {
    const clickEvent = { id: event, time: getCurrentTime() };
    setClickTracker((oldArr) => [...oldArr, clickEvent]);
  };

  const buildResults = () => ({
    startTime,
    userClicks: clickTracker,
    userSelections: content,
    trial,
    submitResults,
    complete,
    endTime: getCurrentTime(),
  });

  const handleGridClick = async (id) => {
    recordClickEvent(`${id}`);
    const index = selections.findIndex((val) => val === id);

    if (index === -1) {
      await setSelections((oldArr) => [...oldArr, id]);
    } else {
      await setSelections((oldArr) => [...oldArr.filter((_, i) => i !== index)]);
    }
  };

  const handleClearClick = async (event) => {
    event.target.blur();
    await recordClickEvent('clear');
    await setSelections([]);
  };

  const handleSubmit = (event) => {
    event.target.blur();
    const result = buildResults();
    setAnswered(true);
    if (selections.length > 0) {
      setCorrectAnswers(0);
      let answeredCorrectly = 0;
      for (let a = 0; a < answers.length; a += 1) {
        const answer = result.userSelections[answers[a].cell];
        if (answer && answer === answers[a].index) {
          answeredCorrectly += 1;
        }
        setCorrectAnswers(answeredCorrectly);
      }
    }
    if (displayResult) {
      const timer = setInterval(() => {
        clearTimeout(timer);
        resultsCallback(result);
      }, 2000);
    } else {
      resultsCallback(result);
    }
  };

  useEffect(() => {
    setStartTime(getCurrentTime());
  }, []);

  useEffect(() => {
    const newContent = {};

    if (selections.length > 0) {
      for (let index = 0; index < selections.length; index += 1) {
        newContent[selections[index]] = index + 1;
      }
    }

    setContent(newContent);
  }, [selections]);

  return (
    <div className="user-select-none d-flex flex-column justify-content-center h-100">
      <div className="user-select-none d-flex flex-column justify-content-center">
        <div className="row justify-content-center">
          <LetterCell cellId={1} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={2} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={3} onClick={handleGridClick} content={content} grid={grid} />
        </div>
        <div className="row justify-content-center">
          <LetterCell cellId={4} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={5} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={6} onClick={handleGridClick} content={content} grid={grid} />
        </div>
        <div className="row justify-content-center">
          <LetterCell cellId={7} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={8} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={9} onClick={handleGridClick} content={content} grid={grid} />
        </div>
        <div className="row justify-content-center">
          <LetterCell cellId={10} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={11} onClick={handleGridClick} content={content} grid={grid} />
          <LetterCell cellId={12} onClick={handleGridClick} content={content} grid={grid} />
        </div>
      </div>
      {!answered && (
        <div className="d-flex justify-content-center">
          <Button className="btn-assessment-secondary mx-1" onClick={(event) => handleClearClick(event)}>
            Clear
          </Button>
          <Button className="btn-assessment-primary mx-1" onClick={(event) => handleSubmit(event)}>
            Submit
          </Button>
        </div>
      )}
      {displayResult && answered && (
        <div className="d-flex justify-content-center mb-4">
          {`You reported ${correctAnswers} out of ${answers.length} letters correctly.`}
        </div>
      )}
    </div>
  );
}

export default OSpanLetterMemory;
